var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-card',{staticClass:"secondary white--text text-center",attrs:{"flat":"","tile":""}},[_c('v-card-text',{staticClass:"white--text pt-0"},[_c('a',{staticClass:"footerColor",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("浙ICP备2021037954号-1")])]),_c('v-divider')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }